import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { HomeSinglePageRoutingModule } from './home-single-routing.module';

import { HomeSinglePage } from './home-single.page';

import { TranslateModule } from '@ngx-translate/core';

import { WelcomePackageOfferPageModule } from '../modals/welcome-package-offer/welcome-package-offer.module';

import { PipeModule } from '../../core/pipe.module';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HomeSinglePageRoutingModule,
    TranslateModule,
    PipeModule,
    WelcomePackageOfferPageModule
  ],
  declarations: [HomeSinglePage]
})
export class HomeSinglePageModule { }
